import { ButtonBase, styled as muiStyled } from '@mui/material'

export const TimerStreakPageContainer = muiStyled('div')(
  ({ theme }) => `   
    display: flex;
    flex-direction:column;
    align-items:center;
    height: 100%;
    gap: 60px;
    justify-content: space-between;
    padding:20px 0px 20px 0px;
`,
)

export const TimerStreakDaysContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    font-weight: 400;
`,
)

export const TimerStreakDayItem = muiStyled('div')(
  ({ theme, highlighted, selected }) => `
    background : ${highlighted ? '#5e3c76' : '#ebebeb'};
    color: ${highlighted ? '#fff' : '#000'};
    border-radius: 50px;
    padding: 0px;
    aspect-ratio: 1;
    width: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0px;
`,
)

export const StreakActionButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    padding: 8px 16px;
    aspect-ratio: 1;
    border-radius: 7px;
    width: 100px;
    background: #ebebeb;
    color: #000;
    display: flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
`,
)

export const PracticeDoneButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    background: #ebebeb;
    color : #000;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 276px;
    margin: 0 10px;
    border-radius: 7px;
    width: 100%;
    padding: 10px 0px;
    transition: 400ms all ${theme.transitions.easing.quickInOut};
    &:disabled {
      background: #2c2c2c;
    }
`,
)

export const StreakButtonsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 226px;
`,
)
